"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwentyFour = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var TwentyFourTip = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\theight: 16px;\n\tfont-size: 12px;\n\tcolor: #666666;\n\tline-height: 16px;\n"], ["\n\theight: 16px;\n\tfont-size: 12px;\n\tcolor: #666666;\n\tline-height: 16px;\n"])));
exports.TwentyFour = function (props) {
    return React.createElement(TwentyFourTip, null, props.text);
};
var templateObject_1;
